var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m74.98 74.98c-48.351 48.353-74.98 112.64-74.98 181.02s26.629 132.667 74.98 181.02c48.353 48.351 112.64 74.98 181.02 74.98l33-260-33-252c-68.38 0-132.667 26.629-181.02 74.98z",
    fill: "#3ba9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.02 74.98c-48.353-48.351-112.64-74.98-181.02-74.98v512c68.38 0 132.667-26.629 181.02-74.98 48.351-48.353 74.98-112.64 74.98-181.02s-26.629-132.667-74.98-181.02z",
    fill: "#6b77e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 256c0 108.075 87.925 196 196 196l22-199-22-193c-108.075 0-196 87.925-196 196z",
    fill: "#e7f2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 60v392c108.075 0 196-87.925 196-196s-87.925-196-196-196z",
    fill: "#d1d5f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.807 263.285-29.899-29.9-46.464 46.465 76.363 76.363 28.193-28.193 18-54.02-18-38.908z",
    fill: "#2ee66b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.092 177-58.092 58.092v92.928l104.556-104.556z",
    fill: "#24b383"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.2314c076.svg";
export { ForwardRef as ReactComponent };